import { User } from "@vviinn/user-managment-client-ts";
import { compareAsStrings } from "../../helpers";

export const sortUsers = (users: User[], sortKey: keyof User) => {
  if (users.length === 0) return users;
  return [...users].sort((user1, user2) =>
    compareAsStrings(user1[sortKey], user2[sortKey]),
  );
};
